import {getPrivateAxios} from '../../libs';
import {Team} from './types';

export const fetchTeamLeave = async (teamId: string) => {
  const {data} = await getPrivateAxios().post<Team>(`/teams/${teamId}/leave`);
  return data;
};
